import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=a7eceba0"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsAndGuidesArticle: require('/home/runner/work/marketing/marketing/components/NewsAndGuidesArticle.vue').default})
